/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image
 */

import AutoImage from './autoimage';
import Image from './image';
import ImageCaption from './imagecaption';
import ImageInsert from './imageinsert';
import ImageResize from './imageresize';
import ImageStyle from './imagestyle';
import ImageTextAlternative from './imagetextalternative';
import ImageToolbar from './imagetoolbar';
import ImageUpload from './imageupload';

export default {
	AutoImage,
	Image,
	ImageCaption,
	ImageInsert,
	ImageResize,
	ImageStyle,
	ImageTextAlternative,
	ImageToolbar,
	ImageUpload
};
